import { Heading, Paragraph } from '@zillow/constellation-10';

interface Props {
  remainingAttempts: number;
}

const TryAgainPage = ({ remainingAttempts }: Props): JSX.Element | null => (
  <>
    <Heading level={3} textStyle="body-lg-bold">
      Your identity was not verified
    </Heading>
    <Paragraph>
      Some of your answers were incorrect so we could not verify your identity. Try again. You have {remainingAttempts}{' '}
      {remainingAttempts === 1 ? 'attempt' : 'attempts'} left.
    </Paragraph>
  </>
);

export default TryAgainPage;
